<script setup>
import { defineProps, computed, watch, ref, defineEmits } from 'vue'
import CardItem from '@/pages/global/verifyMetaData/components/CardItem.vue'
import Subtract from '@/pages/global/verifyMetaData/assets/Subtract.png'
import PhotoLocation from '@/pages/global/verifyMetaData/assets/photo_location.png'
import lang from '@/pages/global/verifyMetaData/lang.json'
import { sign } from './utils'

const defaultLocal =
  navigator.language === 'zh-TW' ? 'zh-TW' : navigator.language.split('-')[0]
const local = ref(defaultLocal)
const languages = new Proxy(lang, {
  get: function (target, property) {
    if (target[property]) {
      return target[property][local.value] || target[property].en
    }
    return ''
  }
})

const props = defineProps({
  metaData: {
    type: Object,
    default: () => ({})
  },
  showErrorStatus: {
    type: Boolean,
    default: false
  }
})

const emits = defineEmits(['track'])
const innerMetaData = ref({})

watch(
  () => props.metaData,
  (newVal) => {
    innerMetaData.value = newVal
  }
)

const handleToGoogleMap = (trackActionType) => {
  const targetUrl = new URL('https://www.google.com/maps')
  targetUrl.searchParams.set(
    'q',
    `${innerMetaData.value.lat}, ${innerMetaData.value.lng}`
  )
  emits('track', trackActionType, { url: targetUrl.toString() })
  window.open(targetUrl.toString(), '_blank')
}

const imgStaticUrl = computed(() => {
  // 生成静态地图 img url
  const res = new URL('https://maps.googleapis.com/maps/api/staticmap')
  const lat = innerMetaData.value.lat
  const lng = innerMetaData.value.lng
  if (!lng || !lat) {
    return ''
  }
  res.searchParams.set('center', `${lat}, ${lng}`)
  res.searchParams.set('zoom', '14')
  res.searchParams.set('size', '335x140')
  res.searchParams.set('scale', 2)
  // res.searchParams.set('key', 'AIzaSyC0_mKAlp8XDrvLFHJzG-sVv2zLZPYfpFw')
  res.searchParams.set('markers', `color:red|${lat},${lng}`)
  res.searchParams.set('key', 'AIzaSyCdHGRW1sUgtlY7v1tSbISorUTTc3A5ohs')

  const resUrl = sign(res.toString(), 'gPTgQ_gY4aMhE6DUUTPxfWlzuTk=')
  console.log('resUrl', resUrl)
  return resUrl
})

const showGoogleMapImg = computed(
  () => innerMetaData.value.lat !== 0 && innerMetaData.value.lng !== 0
)

// address 显示的内容
const addressText = computed(() => {
  if (props.showErrorStatus) {
    return '-'
  } else {
    return (
      innerMetaData.value.address ||
      languages.i_location_data_unavailable_missing_permissions
    )
  }
})

// 是否展示 address 模块
const isShowAddress = () => {
  if (props.showErrorStatus) {
    // 说明接口 status === 2，此时需要展示 address
    return true
  } else if (showGoogleMapImg.value && !innerMetaData.value.address) {
    // 此时 status === 1, 用户关闭了对应权限， 此时展示 address 对应的 i_key
    return true
  } else {
    return false
  }
}
</script>

<template>
  <div class="photo-location-wrapper">
    <div class="title">{{ languages.i_photo_location }}</div>
    <div
      class="googleMapWrapper"
      @click="handleToGoogleMap('map')"
      v-if="showGoogleMapImg"
    >
      <img :src="imgStaticUrl" alt="" />
      <div class="googleMapIcon">
        <img :src="PhotoLocation" alt="" />
      </div>
    </div>

    <div class="content">
      <CardItem
        v-if="isShowAddress"
        :topMsg="languages.i_address"
        :bottomMsg="addressText"
      />
      <!--      :bottomMsg="-->
      <!--      innerMetaData.address ||-->
      <!--      languages.i_location_data_unavailable_missing_permissions-->
      <!--      "-->
      <CardItem
        topMsg="GPS"
        :bottomMsg="`${innerMetaData.lat ? `${innerMetaData.lat},` : ''} ${
          innerMetaData.lng ? innerMetaData.lng : '-'
        }`"
      />
    </div>

    <div
      class="footer"
      @click="handleToGoogleMap('direction')"
      v-if="showGoogleMapImg"
    >
      <div class="btn">
        <div :style="{ width: '20px', height: '20px' }">
          <img :src="Subtract" alt="" />
        </div>
        {{ languages.i_directions }}
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.photo-location-wrapper {
  background: rgba(240, 245, 250, 1);
  margin-top: 20px;
  border-radius: 10px;
  padding-bottom: 30px;

  .title {
    font-weight: 590;
    font-size: 16px;
    padding: 16px 20px;
    border-bottom: 0.5px solid rgba(163, 185, 204, 1);
    color: rgba(61, 110, 153, 1);
  }

  .googleMapWrapper {
    height: 140px;
    width: 100%;
    position: relative;

    .googleMapIcon {
      width: 34px;
      height: 34px;
      position: absolute;
      bottom: 10px;
      right: 10px;
      background: rgba(255, 255, 255, 1);
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;

      img {
        width: 18px;
        height: 18px;
      }
    }
  }

  .content {
    padding: 30px 20px;
    display: flex;
    flex-direction: column;
    gap: 30px;
  }

  .footer {
    padding: 0 20px;

    .btn {
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      border-radius: 8px;
      background: rgba(0, 112, 244, 1);
      font-weight: 590;
      font-size: 17px;
      color: rgba(255, 255, 255, 1);
    }
  }
}
</style>
